import { useTranslation } from 'react-i18next';
import { Box, Button, Hidden, IconButton, Stack, TextField, Typography, useTheme } from '@mui/material';
import CardComponent from '../../components/Card';
import { useState } from 'react';
import {  AddCommunityMemberIcon, ArrowRightSIcon, CommunityMemberIcon, EditIcon, EyeIcon, iconFontSize } from '../../components/IconComponent';
import { GetIconColor } from '../../theme/main_style';
import Container from '../../components/Container';
import SubHeader from '../../components/SubHeader';
import { cache } from '../../utils/cache';
import Modal from '../../components/Modal';
import { communityInvitationState } from '../../enums/contacts';
import { checkActionPermission, getData } from '../../utils/common';
import { obfuscateValue, replaceParamTranslation } from '../../utils/util';

export default function CommunityMembersView(props) {
    const { t } = useTranslation();
    const { members, communitySelected, joinedGroups } = props
    const contactId = cache.getContact().id;
    const isOwner = communitySelected.ownerId === contactId;
    const [openEditCommunityName, setOpenEditCommunityName] = useState(false);
    const [communityName, setCommunityName] = useState(communitySelected.group);

    const { palette } = useTheme();

    const onBack = () => {
        props.setActive("communities")
    }

    
    let isAllowActions = checkActionPermission("CONTACT_MANAGEMENT")
    let isCommunitySelected = false;
    let community = null;
    if (joinedGroups && joinedGroups.length > 0) {
        joinedGroups.forEach(item => {
            if (item.group === communitySelected.group && item.community_owner.id === communitySelected.ownerId) {
                isCommunitySelected = true;
                community = item;
            }
        });
    }

    let current_workspace = getData('current_workspace');
    let isCommunityWorkspace = current_workspace && current_workspace === 'community_owner';
            
            
    const renderRoot = () => {
        return (
            <>
                <Hidden mdDown>
                    <Container showProcessing={props.showLoading} showFooter showHeader subHeader={<SubHeader title={communitySelected.group} variant={'action-buttons'} showBackIcon onGoBack={() => onBack()}/>}>
                        <>
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="flex-end"
                                marginRight={2}
                            >
                                {isCommunitySelected && isAllowActions &&
                                <Button sx={{ width:'20%' }}  color="primary" variant="contained" id="topupWallet/Submit" borderRadius={'50%'}
                                    onClick={() => props.onSwitchRole(community)} 
                                    startIcon={<EyeIcon color={isCommunityWorkspace ? GetIconColor().default : GetIconColor().white} sx={{ fontSize: '16px', color: palette.common.white }}/>}
                                    disabled={isCommunityWorkspace}>
                                    {t('switch_roles')}
                                </Button>}
                            </Stack>
                            {renderContent()}
                        </>
                    </Container>
                </Hidden>
                <Hidden mdUp>
                    <Container showProcessing={props.showLoading} mobileHeader={{
                        show: true,
                        title: communitySelected.group,
                        onBack: () => onBack(),
                    }}>
                        {renderContent()}
                        {isCommunitySelected && isAllowActions &&
                        <Stack direction="row" alignItems="center" justifyContent="center" sx={{position: 'fixed', bottom: '50px', left: 0, width: '100%', px: 2, zIndex: 1300 }}>
                            <Button sx={{ color:palette.common.white }} fullWidth color='primary' variant="contained" id="createCommunity/Submit" borderRadius={'50%'}
                                onClick={() => props.onSwitchRole(community)} 
                                startIcon={<EyeIcon color={isCommunityWorkspace ? GetIconColor().default : GetIconColor().white} sx={{ fontSize: '16px', color: palette.common.white }}/>}
                                disabled={isCommunityWorkspace}>
                                {t('switch_roles')}
                            </Button>
                        </Stack>}
                    </Container>
                </Hidden>
            </>
        )
    }

    const renderContent = () => {
        return (
            <>
                <Stack direction="row" alignItems="center" marginTop={2} marginBottom={1}>
                    {members && members.length > 0 ?
                    <Typography variant="subtitle1">{replaceParamTranslation(t('members_desc'), [communitySelected.group])}</Typography> : 
                    <Typography variant="subtitle1">{replaceParamTranslation(t('no_members_desc'), [communitySelected.group])}</Typography>}
                </Stack>
                <Stack spacing={0} marginTop={2}>
                    <Stack direction="row" alignItems="center" justifyContent="flex-end">
                        {isOwner && 
                        <>
                            <IconButton onClick={() => setOpenEditCommunityName(true)}><EditIcon color={GetIconColor().primary} size={iconFontSize.xs} /></IconButton>
                            <IconButton sx={{marginLeft:2}} onClick={() => props.onAddMember()}><AddCommunityMemberIcon color={GetIconColor().primary} size={iconFontSize.xs} /></IconButton>
                        </>}
                        
                    </Stack>
                </Stack>

                {members.map((item, index) => {
                    const seeFullDetails = isOwner || (item.contact.id === contactId) || (item.contact.id ===communitySelected.ownerId);
                    const isAllowToView = (((item.contact.id === contactId) || isOwner) && (item.contact.id !== communitySelected.ownerId));
                    let name = null;
                    let email = null;
                    let phone = null;
                    if (item.contact && item.contact.first_name) 
                    {
                        name = item.contact.first_name;
                        if(item.contact.last_name){
                            name += " " + item.contact.last_name
                        }
                    }

                    if(item.contact.email)
                    {
                        email = item.contact.email;
                        if(!seeFullDetails){
                            email = obfuscateValue(email)
                        }
                    }

                    if(item.contact.phone && !email){
                        phone = item.contact.phone ? "+" + item.contact.phone.number : null;
                        if(!seeFullDetails){
                            phone = obfuscateValue(phone)
                        }
                    }

                    return (
                    <Box
                        key={`${index}`}
                        mb={1}
                        borderBottom={members.length - 1 === index ? 0 : `1px solid ${palette.border.main}`}
                        sx={{cursor: isAllowToView ?  "pointer" : undefined}}
                        onClick={() => isAllowToView && props.onSeeMember(item)}
                    >
                        <CardComponent paddingY={1} noBorder paddingTop={0}>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Stack direction="row" alignItems="center">
                                    <CommunityMemberIcon color={GetIconColor().default} size={iconFontSize.xxs} />
                                    <Stack marginLeft={2} spacing={0} marginBottom={1}>
                                        <Box
                                            display="flex"
                                            flexDirection={{ xs: 'column', sm: 'row' }}
                                            alignItems={{ sm: 'center' }}
                                            gap={1}
                                        >
                                            {name && <Typography variant="subtitle1">{name}</Typography>}
                                            {email && <Typography variant="subtitle2" style={{ opacity: 0.7 }}>{email}</Typography>}
                                            {phone && <Typography variant="subtitle2" style={{ opacity: 0.7 }}>{phone}</Typography>}
                                        </Box>

                                        <Typography variant="subtitle2" style={{ opacity: 0.7 }}>
                                            {item.is_owner ? t('owner') : 
                                                (item.state==communityInvitationState.PENDING ? t('pending') : t('member'))}
                                        </Typography>
                                    </Stack>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    marginRight={2}
                                    style={{ width: 24, minWidth: 24 }}
                                >
                                    {isAllowToView && <ArrowRightSIcon />}
                                </Stack>
                            </Stack>
                        </CardComponent>
                    </Box>)
                })}

                {openEditCommunityName && 
                    <Modal enableCloseButton isOpen={true} onClose={() => setOpenEditCommunityName(false)} title={t("change_community_name")} maxWidth={'sm'}>
                        <Stack spacing={2} mt={3}>
                        <TextField
                            id="outlined-controlled"
                            label={t("community_name")}
                            value={communityName}
                            onChange={(event) => {
                                setCommunityName(event.target.value);
                            }}
                            />
                            

                            <Button id='addEditPeople/btnSubmit' variant='contained' 
                                onClick={() => {
                                    props.onSubmitCommunityNameChange(communityName)
                                    setOpenEditCommunityName(false)                           
                                }}>{t('submit')}</Button>
                        </Stack>
                    </Modal>
                }
            </>
        )
    }

    return (
        <>{renderRoot()}</>
    )
}
